import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowDownSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 7V13.5859L9 11.5859L7.58594 13L12 17.4141L16.4141 13L15 11.5859L13 13.5859V7H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownSquare;
